import { render, staticRenderFns } from "./DocAPI.vue?vue&type=template&id=6dd8dd54&scoped=true&"
import script from "./DocAPI.vue?vue&type=script&lang=js&"
export * from "./DocAPI.vue?vue&type=script&lang=js&"
import style0 from "./DocAPI.vue?vue&type=style&index=0&id=6dd8dd54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8dd54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
